import styled from "styled-components";
import Chip from "@material-ui/core/Chip";

export const STChip = styled(Chip)`
  margin-right: 3px;
`;
